export const formvalues = (data) => {
    const form = new FormData();
  
    const appendData = (key, value) => {
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          if (item instanceof File) {
            form.append(`${key}[${index}]`, item);
          } else if (typeof item === "object") {
            for (const subKey in item) {
              form.append(`${key}[${subKey}]`, item[subKey]);
            }
          } else {
            form.append(`${key}[${index}]`, String(item));
          }
        });
      } else if (value instanceof File) {
        form.append(key, value);
      } else if (typeof value === "object" && value !== null) {
        form.append(key, JSON.stringify(value));
      } else {
        form.append(key, String(value));
      }
    };
  
    Object.entries(data).forEach(([key, value]) => appendData(key, value));
  
    return form;
  };
  